import { Action, createReducer, on } from '@ngrx/store';
import { getPurchaseHistoryAction, getPurchaseHistoryErrorAction, getPurchaseHistorySuccessAction } from './purchase-history.actions';
import { PurchaseHistoryState } from './purchase-history.state';

const initialState = new PurchaseHistoryState();

const reducer = createReducer(
  initialState,
  on(getPurchaseHistoryAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(getPurchaseHistorySuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.purchaseHistoryItems = payload.purchaseHistoryItems;
    return newState;
  }),
  on(getPurchaseHistoryErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failures;
    return newState;
  })
);

export function purchaseHistoryReducer(state: PurchaseHistoryState | null, action: Action) {
  return reducer(state, action);
}
